/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'
export default {

  createEtestExam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/exam/create", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("CREATE_EXAM", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateAudioFile(context, payload) {
    // console.log(payload)
    var frm = new FormData()
    const json = JSON.stringify(payload.param);
    const blob = new Blob([json], {
      type: 'application/json'
    })
    frm.append("document", blob)
    frm.append("file", payload.file)
    return new Promise((resolve, reject) => {
      axios.put("/api/etest/audio", frm, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        if (response.data.result == 'success') {
          // commit("/CREATE_SUBMIT_MEMBER", response.data.data)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  deleteAudioFile(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/etest/audio/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // createEtestSubject({
  //   commit
  // }, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/etest/subject/create", payload)
  //       .then((response) => {
  //         if (response.data.result == 'success') {
  //           commit("CREATE_SUBJECT", response.data.data)
  //           resolve(response)
  //         }
  //         reject(response)
  //       }).catch((error) => {
  //         reject(error)
  //       })
  //   })
  // },
  createEtestSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/admin-exam/subject", payload)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("CREATE_SUBJECT", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createEtestQuestion({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/question/create", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("CREATE_QUESTION", response.data.data)
            resolve(response.data.data)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateEtestMultiple({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/etest/multiple", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("UPDATE_MULTIPLE", payload)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createEtestMultiple({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/multiple/create", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("CREATE_MULTIPLE", response.data.data)
            resolve(response.data.data)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateEtestExam(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/exam/update", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateEtestSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/subject/update", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("UPDATE_SUBJECT", payload)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createSubjectGrade({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/subject/grade", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_SUBJECT_GRADE", payload)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getSubjectGrade({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/etest/subject/grade", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_SUBJECT_GRADE", response)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateDefectQuestion({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/defect/question/update", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("DELETE_DEFECT_QUESTION", payload)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateEtestQuestion({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/question/update", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("UPDATE_QUESTION", payload)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteEtestQeustion(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/admin-exam/question/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateSubjectState(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/subject/state", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getEtestExam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/etest/exam/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            if (payload == 'current') {
              commit("SET_CURRENT_EXAM_LIST", response.data.data_list)
            } else if (payload == 'schedule') {
              commit("SET_SCHEDULE_EXAM_LIST", response.data.data_list)
            } else if (payload == 'admin'){
              commit("SET_ADMIN_EXAM_LIST", response.data.data_list)
              commit("SET_ALL_EXAM_LIST" , response.data.data_list)
            } else if (payload == 'defect'){
              commit("SET_DEFECT_EXAM_LIST", response.data.data_list)
            } else if (payload == 'admin_test'){
              commit('SET_TEST_EXAM_LIST', response.data.data_list)
            } else {
              commit("SET_WRITING_EXAM_LIST", response.data.data_list)
            }
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getEpracticeExam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/admin/exam-subject/info/" + payload).then((response) => {
        // console.log('KGM',response)
        if (response.data.result == 'success') {
          commit("SET_PRACTICE_EXAM_LIST", response.data.data_list)
          resolve(response)
        }
        reject(resolve)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getEpracticeResearchExam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload)
      axios.get("/api/v2/admin/detail-subject/info/" + payload).then((response) => {
        if (response.data.result == 'success') {
          commit("SET_PRACTICE_EXAM_LIST", response.data.data_list)
          resolve(response)
        }
        reject(resolve)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getCategoryList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/subject/category/" + payload).then((response) => {
        // console.log('KGM',response)
        if (response.data.result == 'success') {
          commit("SET_CATEGORY_LIST", response.data.data_list)
          resolve(response)
        }
        reject(resolve)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getMainCategoryList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/subject/main-category/" + payload).then((response) => {
        // console.log('KGM',response)
        if (response.data.result == 'success') {
          commit("SET_MAIN_CATEGORY_LIST", response.data.data_list)
          resolve(response)
        }
        reject(resolve)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getSubCategoryList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/subject/sub-category/" + payload).then((response) => {
        if (response.data.result == 'success') {
          commit("SET_SUB_CATEGORY_LIST", response.data.data_list)
          resolve(response)
        }
        reject(resolve)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  updateExamState(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/etest/exam/state", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getDefectEtestSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/etest/defect/subject/" + payload)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_SUBJECT_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getEtestSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/etest/subject/" + payload)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_SUBJECT_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getDefectEtestQuestion({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/etest/defect/question/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_QUESTION_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getEtestQuestion({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/etest/question/" + payload)
        .then((response) => {
          // console.log(response)
          if (response.data.result == 'success') {
            commit("SET_ACTIVE_SUBJECT_ID" , payload)
            commit("SET_QUESTION_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getEtestMultiple({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/etest/multiple/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_MULTIPLE_QUESTION_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteQuestion({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/etest/question/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("DELETE_QUESTION", payload)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteMultiple({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/etest/multiple/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("DELETE_MULTIPLE", payload)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getQuestion({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/question/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("ACTIVE_QUESTION", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateAdminExamState(context, payload){
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/etest/exam/state", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateAdminTestState(context, payload){
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/exam/test/state", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
            // commit('UPDATE_ADMIN_TESTING', payload)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateDefect({
    commit
  }, payload){
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/etest/question/defect", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("UPDATE_QUESTION_COMMAND", payload)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createSubjectGradeLevel(context, payload){
    return new Promise((resolve, reject) => {
      axios.post("/api/app/subject/grade", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updatePracticeState({
    commit
  }, payload){
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/subject/type-state", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_PRACTICE_EXAM_STATE", payload)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updatePracticeTypeInfo({
    commit
  }, payload){
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/question/type-info", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_QUESTION_TYPE", payload)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateSubjectGradeLevel(context, payload){
    return new Promise((resolve, reject) => {
      axios.put("/api/app/subject/grade", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  uploadUnivImage(context, payload) {
    var frm = new FormData()
      frm.append("id",  payload.id)
      frm.append("file",  payload.file)
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/tar_univ/univ_image" , frm, {headers:{'Content-Type': 'multipart/form-data'}})
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getUnivImage({
    commit
  }, payload){
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/tar_univ/univ_image?id="+ payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_UNIV_IMAGE", response.data.data)
            resolve(response.data.data)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getSubjectGradeLevel(context, payload){
    return new Promise((resolve, reject) => {
      axios.get("/api/app/subject/grade/"+ payload)
        .then((response) => {
          if (response.data.result == 'success') {
            // commit("SET_SUBJECT_GRADE", response.data.data_list)
            resolve(response.data.data_list)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateSelectExamInfo(context , payload){
    return new Promise((resolve, reject)=> {
      axios.post('/api/v2/admin/exam-info' , payload).then((response) => {
        if(response.data.result == 'success') {
          resolve(response.data.data_list)
        }
        reject(response)
      }).catch((error)=> {
        reject(error)
      })
    })
  },
  getExamDateId({
      commit
    }, payload){
      return new Promise((resolve, reject)=> {
        axios.get('/api/v2/admin/exam/date/' + payload).then((response) => {
          if(response.data.result == 'success') {
            commit("EXAM_DATE_ID_LIST" , response.data.data_list)
            resolve(response.data.data_list)
          }
          reject(response)
        }).catch((error)=> {
          reject(error)
        })
      })
    },
  getSelectExamInfo({
      commit
    }, payload){
      return new Promise((resolve, reject)=> {
        axios.get('/api/v2/admin/exam-info/' + payload).then((response) => {
          if(response.data.result == 'success') {
            commit("NEXT_EXAM_LIST_INFO" , response.data.data_list)
            resolve(response.data.data_list)
          }
          reject(response)
        }).catch((error)=> {
          reject(error)
        })
      })
    },
    getSelectWeekInfo({
        commit
      }, payload){
        return new Promise((resolve, reject)=> {
          console.log(payload)
          axios.get('/api/v2/admin/exam/' + payload).then((response) => {
            if(response.data.result == 'success') {
              commit("WEEK_LIST_INFO" , response.data.data_list)
              resolve(response.data.data_list)
            }
            reject(response)
          }).catch((error)=> {
            reject(error)
          })
        })
      },
    setWeekInfo({
        commit
      }, payload){
        return new Promise((resolve, reject) => {
          axios.post('/api/v2/admin/exam/date' , payload).then((response) => {
            if(response.data.result == 'success') {
              commit("WEEK_LIST_INFO" , response.data.data_list)
              resolve(response.data.data_list)
            }
            reject(response)
          }).catch((error)=> {
            reject(error)
          })
        })
      },
    changePlanDate({
        commit
      }, payload){
        return new Promise((resolve, reject) => {
          axios.put('/api/v2/admin/exam/date' , payload).then((response) => {
            if(response.data.result == 'success') {
              commit("WEEK_LIST_INFO" , response.data.data_list)
              resolve(response.data.data_list)
            }
            reject(response)
          }).catch((error)=> {
            reject(error)
          })
        })
      },
    deletePlanDate({
        commit
      }, payload){
        return new Promise((resolve, reject) => {
          axios.delete('/api/v2/admin/exam/date/' + payload).then((response) => {
            if(response.data.result == 'success') {
              commit("WEEK_LIST_INFO" , response.data.data_list)
              resolve(response.data.data_list)
            }
            reject(response)
          }).catch((error)=> {
            reject(error)
          })
        })
      },
    setSelectExamInfo(context, payload) {
      return new Promise((resolve, reject) => {
        console.log(payload)
        axios.put("/api/v2/admin/exam-info", payload)
          .then((response) => {
            if (response.data.result == 'success') {
              resolve(response)
            }
            reject(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },
  changeExamInfo(context, payload) {
    return new Promise((resolve, reject)=> {
      console.log(payload)
      axios.put('/api/v2/admin/exam-info' , payload).then((response) => {
        if(response.data.result == 'success') {
          resolve(response.data.data_list)
        }
        reject(response)
      }).catch((error)=> {
        reject(error)
      })
    })
  },
  deleteExamInfo(context, payload) {
    return new Promise((resolve, reject)=> {
      console.log(payload)
      axios.delete('/api/v2/admin/exam-info/' + payload).then((response) => {
        if(response.data.result == 'success') {
          resolve(response.data.data_list)
        }
        reject(response)
      }).catch((error)=> {
        reject(error)
      })
    })
  },
  getSubjectType({
    commit
  }){
    return new Promise((resolve, reject) => {
      axios.get("/api/v1/exam/subject-type")
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_SUBJECT_TYPE_LIST", response.data.data_list)
            resolve(response.data.data_list)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getSubjectDetail({
    commit
  }){
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/subject-master")
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_SUBJECT_DETAIL_TYPE_LIST", response.data.data_list)
            resolve(response.data.data_list)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getSubjectDetailType({
    commit
  }){
    return new Promise((resolve, reject) => {
      axios.get("/api/school/subject/all")
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_SUBJECT_DETAIL_TYPE_LIST", response.data.data)
            resolve(response.data.data_list)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getSubjectCodeInfo({
    commit
  }){
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/subject-master")
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_SUBJECT_CODE_LIST", response.data.data_list)
            resolve(response.data.data_list)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  showUniv({
    commit
  }){
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/tar_univ/univ_list")
        .then((response) => {
          if (response.data.result == 'success') {
            commit('GET_UNIV_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
   saveUnivInfo({
     commit
   }, payload) {
     return new Promise((resolve, reject) => {
       axios.put("/api/v2/tar_univ/univ", payload)
         .then((response) => {
           if (response.data.result == 'success') {
             commit('SAVE_UNIV_INFO', response.data.data)
             resolve(response)
           }
           reject(response)
         })
         .catch((error) => {
           reject(error)
         })
     })
   },
   getMajorList({
     commit
   }, payload) {
     return new Promise((resolve, reject) => {
       axios.get("/api/v2/tar_univ/univ_major_list/"+ payload)
       .then((response) =>{
         if(response.data.result == 'success'){
           commit("GET_MAJOR_LIST", response.data.data)
           console.log(response.data.data)
           resolve(response)
         }
         reject(resolve)
       }).catch((error) => {
         reject(error)
       })
     })
   },
   addMajorItem({
     commit
   }, payload) {
     return new Promise((resolve, reject) => {
       axios.post("/api/v2/tar_univ/univ_major", payload)
         .then((response) => {
           if (response.data.result == 'success') {
             commit("ADD_MAJOR_ITEM", response.data.data)
             resolve(response)
           }
           reject(response)
         })
         .catch((error) => {
           reject(error)
         })
     })
   },
   saveMajorItem({
     commit
   }, payload) {
     return new Promise((resolve, reject) => {
      axios.put("/api/v2/tar_univ/univ_major", payload).then(()=> {
        axios.get("/api/v2/tar_univ/univ_major_list/" + payload.univ_id)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response.data.data)
            commit('GET_MAJOR_LIST', response.data.data)
            resolve(response)
          }
            reject(response)
          })
          .catch((error) => {
            reject(error)
          })
        }) 
      })
   },
   deleteMajorItem ({ commit }, payload) {
     return new Promise((resolve, reject) => {
       console.log(payload)
       axios.delete("/api/v2/tar_univ/univ_major/"+ payload)
         .then((response) => {
           if(response.data.result == 'success'){
           commit('DEL_MAJOR_ITEM', payload)
           resolve(response)
         }
         reject(response)
         })
         .catch((error) => { reject(error) })
     })
   },
   addMajorGrd({
     commit
   }, payload) {
     return new Promise((resolve, reject) => {
       console.log(payload)
       axios.post("api/v2/tar_univ/univ_major_grd", payload)
         .then((response) => {
           if (response.data.result == 'success') {
             console.log(response.data.data)
             commit('ADD_MAJOR_GRD', response.data.data)
             resolve(response)
           }
           reject(response)
         })
         .catch((error) => {
           reject(error)
         })
     })
   },
   changeMajorGrd({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.put("api/v2/tar_univ/univ_major_grd", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response.data.data)
            commit('ADD_MAJOR_GRD', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
   getMajorGrdList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/tar_univ/univ_major_grd_list/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response.data.data)
            commit('SET_MAJOR_GRD_LIST', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getGrdDetail({
    commit
    }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/tar_univ/univ_major_grd_sub_list/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response.data.data)
            commit('SET_MAJOR_GRD_DETAIL', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  saveMajorGrd(context, payload) {
     return new Promise((resolve, reject) => {
       axios.put("api/v2/tar_univ/univ_major_grd" , payload)
         .then((response) => {
           if (response.data.result == 'success') {
             console.log(response.data.data)
             resolve(response)
           }
           reject(response)
         })
         .catch((error) => {
           reject(error)
         })
     })
   },
  deleteMajorGrd({
    commit
    }, payload) {
     return new Promise((resolve, reject) => {
       axios.delete("api/v2/tar_univ/univ_major_grd/" + payload)
         .then((response) => {
           if (response.data.result == 'success') {
             console.log(response.data.data)
             commit('SET_MAJOR_GRD_LIST', response.data.data)
             resolve(response)
           }
           reject(response)
         })
         .catch((error) => {
           reject(error)
         })
     })
   },
}
